import React from 'react';
import DangerAlert from '../common/alerts/DangerAlert';
import { RoutePaths } from 'Constants/Common';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RepairRequestError = (): JSX.Element => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const onBackButtonClick = () => {
        navigate(RoutePaths.Home);
    };
    return (
        <>
            <div className='alert-container'>
                <DangerAlert
                    includeImage={false}
                    message={t('registration_error')}
                />
            </div>
            <div className='bottom-navigation'>
                <button
                    aria-label='back-button'
                    className='btn btn-secondary progress-button'
                    onClick={() => onBackButtonClick()}>
                    {t('back')}
                </button>
            </div>
        </>
    );
};

export default RepairRequestError;
